import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EditableHTML from "./EditableHTML";
import { SitePages } from "@/lib/api";

const Footer = ({ content = {} }) => {
  const [navPages, setNavPages] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const all = await SitePages.list(true);
        setNavPages(all.filter((p) => p.show_in_nav));
      } catch {}
    })();
  }, []);

  return (
    <footer className="relative border-t border-white/5 bg-slate-950/80 backdrop-blur-xl mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display font-black text-2xl text-white">ATC</div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mt-1">Mold & Water Restoration</div>
          <EditableHTML html={content.footer_tagline} className="text-slate-400 text-sm mt-4 max-w-xs" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-3">Explore</div>
          <ul className="space-y-2 text-slate-300 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/equipment" className="hover:text-white">Equipment</Link></li>
            {navPages.map((p) => (
              <li key={p.id}>
                <Link to={`/p/${p.slug}`} className="hover:text-white" data-testid={`footer-page-${p.slug}`}>
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-3">Contact</div>
          <EditableHTML html={content.contact_phone} className="text-slate-300 text-sm" />
          <EditableHTML html={content.contact_email} className="text-slate-300 text-sm mt-1" />
          <EditableHTML html={content.contact_address} className="text-slate-400 text-xs mt-2" />
          <Link to="/admin/login" className="inline-flex items-center gap-1.5 mt-6 text-xs text-slate-500 hover:text-slate-300 transition" data-testid="footer-admin-link">
            <span className="h-1 w-1 rounded-full bg-atc-green/60" /> Admin login
          </Link>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} ATC Mold & Water Restoration. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
